import { Mark, mergeAttributes } from '@tiptap/core';

export interface PiiRedactOptions {
  HTMLAttributes: Record<string, any>;
}

export const PiiRedact = Mark.create<PiiRedactOptions>({
  name: 'piiRedact',

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  addAttributes() {
    return {
      piiType: {
        default: null,
        parseHTML: element => element.getAttribute('data-pii-type'),
        renderHTML: attributes => {
          if (!attributes.piiType) {
            return {};
          }
          return {
            'data-pii-type': attributes.piiType,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-pii-type]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
      0,
    ];
  },
});
